import React from 'react'
import CartContext, { ICartContext } from '../../contexts/CartContext'

const useCartContext = (): ICartContext => {
  const ctx = React.useContext(CartContext)

  if (!ctx.isChildOfProvider) {
    throw new Error('"useCartContext" must be used as a child of the cart context provider')
  }

  return ctx
}

export default useCartContext
